import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Stack,
  IconButton,
  alpha,
} from '@mui/material';
import { Twitter, Mail } from '@mui/icons-material';

export const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        background: alpha('#1e293b', 0.97),
        color: '#ffffff',
        py: 6,
        pb: 4,
        mt: 10,
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography variant="body2" sx={{ color: alpha('#fff', 0.7) }}>
              © {new Date().getFullYear()} addrs. All rights reserved.
            </Typography>
            <Typography variant="caption" sx={{ color: alpha('#fff', 0.5) }}>
              Made with ❤️ for the crypto community
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1}>
            <Link
              href="http://twitter.com/not_pr0"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'none' }}
            >
              <IconButton
                size="small"
                sx={{
                  background: alpha('#ffffff', 0.1),
                  color: '#ffffff',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    background: alpha('#ffffff', 0.2),
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Twitter fontSize="small" />
              </IconButton>
            </Link>
            <Link
              href="https://discord.gg/An5ARMmE"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'none' }}
            >
              <IconButton
                size="small"
                title="Discord"
                sx={{
                  background: alpha('#ffffff', 0.1),
                  color: '#ffffff',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    background: alpha('#ffffff', 0.2),
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Box sx={{ fontSize: '1rem', fontWeight: 'bold' }}>𝖘</Box>
              </IconButton>
            </Link>
            <Link
              href="mailto:hey@addrs.to"
              sx={{ textDecoration: 'none' }}
            >
              <IconButton
                size="small"
                sx={{
                  background: alpha('#ffffff', 0.1),
                  color: '#ffffff',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    background: alpha('#ffffff', 0.2),
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <Mail fontSize="small" />
              </IconButton>
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
